<div class="border-bottom container-fluid mw-100 bg-light">
  @if (consignment()) {
    <div class="row px-2 py-2 gx-4 main-row">
      <div class="col-auto d-none d-md-flex align-items-center" [style.width.px]="selectionWidth">
        @if (selectable()) {
          <app-selection-checkbox
            [ngModel]="selected() ? checkboxSelectionState.selected : checkboxSelectionState.unselected"
            (ngModelChange)="selectionToggled.emit()"></app-selection-checkbox>
        }
      </div>
      <div class="col-auto px-0 d-flex align-items-center">
        <button #collapseButton type="button" class="btn p-2 rounded-circle action-btn-lg"
                (click)="collapsed.set(!collapsed())"
                [ngClass]="collapsible() ? '' : 'invisible'"
                data-bs-toggle="collapse"
                [attr.data-bs-target]="'#'+validSelector(consignment().masterConsignment.consignmentNumber)"
                [attr.aria-controls]="validSelector(consignment().masterConsignment.consignmentNumber)"
                aria-expanded="false">
          <span class="h1 m-0 align-top text-primary">
            <i class="fa-light fa-fw" [ngClass]="collapsed() ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
          </span>
        </button>
      </div>
      <div class="col col-xl-2 col-xxl-1 d-flex align-items-center flex-grow-1 flex-md-grow-0 crn-section">
        <div class="h-100 w-0 d-flex flex-grow-1 flex-column align-items-stretch justify-content-center">
          <div class="d-flex w-100 align-items-stretch">
            <span class="text-info d-inline-block text-truncate mw-100 cursor-pointer h2 text-info hover-underline mb-0"
                  (click)="editConsignment()" [title]="consignment().masterConsignment.consignmentNumber">
              <app-highlight [term]="term()" [result]="consignment().masterConsignment.consignmentNumber" (textHighlighted)="expandOverviewItem(null)"></app-highlight>
            </span>
            @if (consignment().cancelled) {
              <app-tooltip placement="top" class="ms-2">
                <span class="fa text-danger fa-fw fa-ban"></span>
                <span class="tooltipContent">Cancelled</span>
              </app-tooltip>
            }
            @if (consignment().draft && !consignment().cancelled) {
              <app-tooltip placement="top" class="ms-2">
                <span class="fa-light text-muted fa-fw fa-pencil"></span>
                <span class="tooltipContent">Consignment in draft, it has not been declared yet</span>
              </app-tooltip>
            }
          </div>
          <div class="d-flex align-items-center">
            @if (consignment().transhipment && !consignment().transhipment.cancelled) {
              <span class="fa fa-fw fa-kit fa-light fa-pb-ship-to-ship sub-text me-2" [style.line-height.rem]="1.25"></span>
              <span>Transhipment</span>
            } @else {
              <span class="fa fa-fw fa-light fa-arrow-down-to-line sub-text me-2" [style.line-height.rem]="1.25"></span>
              <span>Inbound</span>
            }
          </div>
        </div>
      </div>
      <div class="col col-xl-2 col-xxl-1 d-none d-vlg-flex flex-column align-items-stretch justify-content-center text-truncate dropdown"
           [style.min-width.px]="200">
        @if (consignment().crn) {
          <button class="btn btn-plain p-0 d-inline-block text-truncate mw-100 underline-tertiary link-underline-tertiary link-primary text-body text-start"
                  [title]="consignment().crn" data-bs-toggle="dropdown">
            <app-highlight [term]="term()" [result]="consignment().crn" emptyText="unknown" (textHighlighted)="expandOverviewItem(null)"></app-highlight>
            <span class="ms-1 m-0 text-primary">
              <i class="fa-light fa-fw fa-chevron-down"></i>
            </span>
          </button>
          <ul class="dropdown-menu position-fixed" style="cursor: pointer">
            <a class="dropdown-item" [routerLink]="'/details/' + consignment().crn" target="_blank">
              <i class="fa-light fa-fw fa-arrow-up-right-from-square"></i>
              Open visit
            </a>
            <a class="dropdown-item" [routerLink]="'/cargo/' + consignment().crn">
              <i class="fa-light fa-fw fa-filter"></i>
              Filter overview by this CRN
            </a>
          </ul>
        } @else {
          <span class="d-inline-block text-truncate mw-100" [title]="consignment().masterConsignment.voyageNumber">
            <app-highlight [term]="term()" [result]="consignment().masterConsignment.voyageNumber" emptyText="unknown" (textHighlighted)="expandOverviewItem(null)"></app-highlight>
          </span>
        }
        <span>{{vehicleValue()}}</span>
      </div>
      <div class="d-none d-xxl-block col-xxl-2">
        <app-movement-icons [movements]="movementsOfPlaces()" [term]="term()" [showDate]="false" [hasMiddleRow]="false"
                            [plain]="true"></app-movement-icons>
      </div>
      @if (movementsOfTerminal()) {
        <div class="d-none d-xxl-block col-xxl">
          <span class="col-12 arrival-date" [ngClass]="(!!movementsOfTerminal().date ? '' : ' text-muted ')">
            <span>
              {{ (movementsOfTerminal().date | date:'dd MMM HH:mm') || 'No date' }}
              {{ consignment().masterConsignment.unloadingAta ? '(ATA)' : '(ETA)'}}
            </span>
          </span>
          <div class="col-12 position-relative" [style.height.rem]="1.5">
            <div class="position-absolute d-flex align-items-center h-100 w-100 pe-2">
              <span class="me-2 text-truncate" style="min-width: 0" [ngClass]="(!!movementsOfTerminal().date ? '' : ' text-muted ')">
                <app-highlight [term]="term()" [result]="movementsOfTerminal().name" (textHighlighted)="expandOverviewItem(null)"></app-highlight>
              </span>
            </div>
          </div>
        </div>
      }
      <div class="col-auto ms-auto">
        <div class="row gy-2 gx-3">
          <div class="col-auto d-flex flex-column status-column status-column-left">
            <div class="row g-0 gx-2">
              <div class="col-auto d-none d-lg-flex flex-column">
                @if (showTsStatus()) {
                  <span (click)="customsNlStatusIndicator.toggleElement()" class="d-none d-lg-inline-block text-start cursor-pointer hover-underline">
                    Customs NL
                  </span>
                }
                @if (terminalStatuses()?.length) {
                  <span (click)="terminalStatusIndicator.toggleElement()" class="d-none d-lg-inline-block text-start cursor-pointer hover-underline">
                    Terminal
                  </span>
                }
              </div>
              <div class="col d-flex flex-column">
                <app-status-indicator #customsNlStatusIndicator [ngClass]="showTsStatus() ? 'd-block' : 'd-none'"
                                      [messageStatuses]="customsNlStatus()" summarySize="vlg"></app-status-indicator>
                <app-status-indicator #terminalStatusIndicator
                                      [ngClass]="terminalStatuses()?.length ? 'd-block' : 'd-none'"
                                      [messageStatuses]="terminalStatuses()" summarySize="vlg"></app-status-indicator>
              </div>
            </div>
          </div>
          <div class="col-auto d-flex flex-column status-column status-column-right">
            <div class="row g-0 gx-2">
              <div class="col-auto d-none d-lg-flex flex-column">
                @if (customsEuStatus().length) {
                  <span (click)="euStatusIndicator.toggleElement()" class="d-none d-sm-inline-block text-start cursor-pointer hover-underline">
                    Customs EU
                  </span>
                }
                <!--                <span class="d-none d-sm-inline-block text-start cursor-pointer hover-underline">-->
                <!--                  Release Party-->
                <!--                </span>-->
              </div>
              <div class="col d-flex flex-column">
                <app-status-indicator #euStatusIndicator [messageStatuses]="customsEuStatus()"></app-status-indicator>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-auto d-none d-xl-flex flex-column align-items-end justify-content-center text-truncate" [style.width.px]="120">
        <span class="d-inline-block text-truncate mw-100 text-end">{{ totalWeight() | numberFormat }} kg</span>

        <span class="d-inline-block text-truncate mw-100 text-end underline-tertiary link-underline-tertiary link-primary text-body cursor-pointer"
              (click)="collapsed.set(!collapsed())"
              [ngClass]="collapsible() ? '' : 'invisible'"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#'+validSelector(consignment().masterConsignment.consignmentNumber)"
              [attr.aria-controls]="validSelector(consignment().masterConsignment.consignmentNumber)"
              aria-expanded="false">
        @if (consignment().equipmentCount) {
            <i class="fa fa-fw fa-light fa-container-storage me-1 text-muted"></i>
            <span>{{ equipmentCount() | numberFormat }}</span>
        } @else {
            <i class="fa fa-fw fa-light fa-mound me-1 text-muted"></i>
            <span>{{ goodsItems().length | numberFormat }}</span>
        }
        </span>
      </div>
      <div class="col-auto d-flex flex-row align-items-center justify-content-center dropdown px-2">
        <a class="btn rounded-circle p-2 text-primary h1 mb-0 action-btn-lg" type="button"
           (click)="editConsignment()">
          <i class="fa-light fa-chevron-right"></i>
        </a>
        <button class="d-none d-md-block btn rounded-circle p-2 text-primary h1 mb-0 action-btn-lg" type="button"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fa-light fa-ellipsis-vertical"></i>
        </button>
        <div class="dropdown-menu position-fixed">
          @if (consignment().crn) {
            <a
              class="dropdown-item" [routerLink]="'/details/' + consignment().crn" target="_blank">
              <i class="fa-light fa-fw fa-arrow-up-right-from-square"></i>
              Open visit
            </a>
          }
          @if (appContext.isAdmin()) {
            <button class="btn dropdown-item" (click)="refreshSummary()">
              <i class="fa-light fa-arrows-rotate"></i>
              Refresh summary
            </button>
          }
          <button class="btn dropdown-item" (click)="duplicate()">
            <i class="fa-light fa-copy"></i>
            Duplicate B/L
          </button>
          @if (!consignment().cancelled && consignment().crn && utils.allowedToAddTranshipment() && !consignment().transhipment) {
            <button class="btn dropdown-item" (click)="createTranshipment()">
              <i class="fa-light fa-plus"></i>
              Create Transhipment
            </button>
          }
          @if (appContext.isAdmin() && consignment().emhProcess; as emhProcess) {
            @if (emhProcess.emhProcessId) {
              <button class="btn dropdown-item"
                      (click)="portVisitUtils.redirectToMessageManagement(emhProcess.emhProcessId)">
                <i class="fa-light fa-inbox"></i>
                View IFTMCS message
              </button>
            }
            @if (emhProcess.houseEmhProcesses) {
              @for (entry of entries(emhProcess.houseEmhProcesses); track trackByKey($index, entry)) {
                <button class="btn dropdown-item" (click)="portVisitUtils.redirectToMessageManagement(entry[1])">
                  <i class="fa-light fa-inbox"></i>
                  View House B/L IFTMCS ({{ entry[0] }})
                </button>
              }
            }
          }
        </div>
      </div>
    </div>
  }
</div>

@if (collapsible()) {
  <div class="collapse" [id]="validSelector(consignment().masterConsignment.consignmentNumber)">
    @for (equipment of consignmentEquipment(); track utils.trackByGoodsItemAndEquipment(i, equipment); let i = $index) {
      <app-consignment-equipment-overview-item
        [ngClass]="!!childItemsShownByFilter().length && !childItemsShownByFilter().includes(equipment.equipment.equipmentNumber) ? 'd-none' : ''"
        [equipment]="equipment" [term]="term()"
        [consignmentProcessId]="consignment().consignmentProcessId"
        [selectable]="false" (highlighted)="expandOverviewItem($event)"></app-consignment-equipment-overview-item>
    }
    @for (goodsItem of goodsItems(); track utils.trackByGoodsItemWithHouseConsignments(i, goodsItem); let i = $index) {
      <app-consignment-bulk-goods-overview-item
        [ngClass]="!!childItemsShownByFilter().length && !childItemsShownByFilter().includes(''+goodsItem.goodsItem.goodsItemNumber) ? 'd-none' : ''"
        [goodsItem]="goodsItem" [term]="term()"
        [consignmentProcessId]="consignment().consignmentProcessId"
        [inspections]="consignment().masterConsignment.bulkInspections"
        [selectable]="false" (highlighted)="expandOverviewItem($event)"></app-consignment-bulk-goods-overview-item>
    }
    @if (!!childItemsShownByFilter().length && (childItemsShownByFilter().length < (consignmentEquipment().length + goodsItems().length))) {
      <div class="border-bottom">
        <div
          class="btn btn-outline-secondary py-2 border-0 rounded-0 d-flex align-items-center justify-content-center text-primary cursor-pointer"
          (click)="childItemsShownByFilter.set([])">
          @if (consignmentEquipment()?.length) {
            <span>Show all {{ consignmentEquipment().length + goodsItems().length }} equipment</span>
          } @else {
            <span>Show all {{ goodsItems().length }} goods</span>
          }
          <i class="fa fa-light fa-chevron-down ms-2"></i>
        </div>
      </div>
    } @else {
      <div class="border-bottom">
        <div class="btn btn-outline-secondary py-2 border-0 rounded-0 d-flex align-items-center justify-content-center text-primary cursor-pointer"
             (click)="collapsed.set(!collapsed())"
             [ngClass]="collapsible() ? '' : 'invisible'"
             data-bs-toggle="collapse"
             [attr.data-bs-target]="'#'+validSelector(consignment().masterConsignment.consignmentNumber)"
             [attr.aria-controls]="validSelector(consignment().masterConsignment.consignmentNumber)"
             aria-expanded="false">
          <i class="fa fa-light fa-chevron-up me-2"></i>
          @if (consignmentEquipment()?.length) {
            <span>Collapse {{ consignmentEquipment().length + goodsItems().length }} equipment</span>
          } @else {
            <span>Collapse {{ goodsItems().length }} {{goodsItems().length === 1 ? 'good' : 'goods'}}</span>
          }
        </div>
      </div>
    }
  </div>
}
